export default __webpack_public_path__ + "static/media/logo-2.af551e6e.png";